import { useState } from "react"
import Layout from "../../sections/Layout"
import { NormalUserContainer } from "../../styleComponents/NormalUserStyle"
import { useEffect } from "react";
import { Avatar, Card, Spinner } from "@chakra-ui/react";
import StatusShow from "../../sections/StatusShow";
import Moment from "react-moment";
import { HomeContainer } from "../../styleComponents/HomeStyle";
import Axios from "../../utils/httpClient";
import { Link } from "react-router-dom";

const Partition = () => {
    const [parts, setParts] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        getApps()
    }, [])
    const getApps = () => {
        setLoading(true);
        Axios().get('api/v1/account/partition/')
        .then(res=>{
            setParts(res?.data??[])
        }).catch(e=>{
        }).finally(()=>{
            setLoading(false);
        })
    }
    return(<>
        <Layout>
            <HomeContainer>
                <NormalUserContainer>
                    <div className="apps">
                        <div className="head">
                            <h1>Bo'limlar ({parts.length} ta)</h1>
                        </div>
                        {loading?<div>
                            <Card className="loading_target">
                                <Spinner  size='lg'
                                    thickness='4px'
                                    speed='0.65s'
                                    emptyColor='gray.200'
                                    color='rgb(34, 195, 94)'
                                />
                            </Card>
                        </div>:<>
                        {parts.map((item, index)=>(
                            <div key={index}>
                                <Card>+
                                    <div className="app_head" style={{padding: 0}}>
                                        <Link to={`/users?partition=${item?.id}`} className="app_ball">{item?.name}</Link> 
                                    </div>  
                                </Card>
                            </div>
                        ))}</>}
                    </div>
                </NormalUserContainer>
            </HomeContainer>
        </Layout>
    </>)
}
export default Partition